// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Ozba","vLegacy":"SelectSecondary_vLegacy__1CO-G","error":"SelectSecondary_error__1XWxf","disabled":"SelectSecondary_disabled__1gWq5"};